import React, { useState } from 'react';
import axios from 'axios';
import LandingPageNavbar from '../LandingPage/LandingPageNavbar';
import LandingPageFooter from '../LandingPage/LandingPageFooter';
import './Contact.css';

const CONTACT = {
  address: 'Nexorah AI, 12645 Memorial Dr, Suite F1 #1221, Houston, TX 77024, USA',
  phone: '+1 713-399-0222',
  phoneHref: 'tel:+17133990222',
  email: 'admin@nexorahai.com',
};

const SUBJECTS = [
  'General question',
  'Courses & modules',
  'Subscription & billing',
  'Technical support',
  'Other',
];

const baseurl = process.env.REACT_APP_BASE_URL || 'http://localhost:8000/api';

export default function Contact() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus('sending');
    setError('');

    try {
      await axios.post(`${baseurl}/accounts/contact/`, {
        name: form.name.trim(),
        email: form.email.trim(),
        subject: form.subject,
        message: form.message.trim(),
      });
      setStatus('sent');
      setForm({ name: '', email: '', subject: '', message: '' });
    } catch (err) {
      const apiError =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        'We could not send your message. Please try again.';
      setError(typeof apiError === 'string' ? apiError : 'We could not send your message. Please try again.');
      setStatus('error');
    }
  };

  return (
    <div className="contact-page">
      <LandingPageNavbar />
      <main className="contact-main">
        <div className="contact-inner">
          <div className="contact-info">
            <p className="contact-eyebrow">GET IN TOUCH</p>
            <h1 className="contact-title">Contact Us</h1>
            <p className="contact-lead">
              We&apos;re here to help. Reach out for any questions about our courses, subscriptions, or technical support.
            </p>

            <ul className="contact-cards">
              <li className="contact-card">
                <span className="contact-card-icon" aria-hidden="true">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                    <path d="M12 21s7-5.2 7-11a7 7 0 10-14 0c0 5.8 7 11 7 11z" stroke="#2979FF" strokeWidth="1.8" />
                    <circle cx="12" cy="10" r="2.4" stroke="#2979FF" strokeWidth="1.8" />
                  </svg>
                </span>
                <div>
                  <h2>Address</h2>
                  <p>{CONTACT.address}</p>
                </div>
              </li>
              <li className="contact-card">
                <span className="contact-card-icon" aria-hidden="true">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                    <path d="M6.5 4.5h3l1.5 4-2 1.2a12 12 0 005.3 5.3l1.2-2 4 1.5v3A2 2 0 0117.5 19 13.5 13.5 0 015 6.5a2 2 0 011.5-2z" stroke="#2979FF" strokeWidth="1.8" strokeLinejoin="round" />
                  </svg>
                </span>
                <div>
                  <h2>Phone</h2>
                  <p><a className="contact-plain-link" href={CONTACT.phoneHref}>{CONTACT.phone}</a></p>
                </div>
              </li>
              <li className="contact-card">
                <span className="contact-card-icon" aria-hidden="true">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="5" width="18" height="14" rx="2" stroke="#2979FF" strokeWidth="1.8" />
                    <path d="M4 7l8 6 8-6" stroke="#2979FF" strokeWidth="1.8" strokeLinecap="round" />
                  </svg>
                </span>
                <div>
                  <h2>Email</h2>
                  <p><a className="contact-plain-link" href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a></p>
                </div>
              </li>
            </ul>
          </div>

          <div className="contact-form-wrap">
            <form className="contact-form" onSubmit={handleSubmit} aria-label="Send us a message">
              <h2>Send us a message</h2>

              <label htmlFor="contact-name">Full Name *</label>
              <input
                id="contact-name"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Your name"
                required
                disabled={status === 'sending'}
              />

              <label htmlFor="contact-email">Email *</label>
              <input
                id="contact-email"
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Your email"
                required
                disabled={status === 'sending'}
              />

              <label htmlFor="contact-subject">Subject</label>
              <select
                id="contact-subject"
                name="subject"
                value={form.subject}
                onChange={handleChange}
                disabled={status === 'sending'}
              >
                <option value="">Select a topic</option>
                {SUBJECTS.map((topic) => (
                  <option key={topic} value={topic}>{topic}</option>
                ))}
              </select>

              <label htmlFor="contact-message">Message *</label>
              <textarea
                id="contact-message"
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder="Your message..."
                rows={5}
                required
                disabled={status === 'sending'}
              />

              <button type="submit" disabled={status === 'sending'}>
                {status === 'sending' ? 'Sending…' : 'Send Message'}
              </button>

              {status === 'sent' && (
                <p className="contact-form-thanks">
                  Thanks — your message was sent to our team. We&apos;ll reply soon.
                </p>
              )}
              {status === 'error' && (
                <p className="contact-form-error" role="alert">
                  {error}
                </p>
              )}
            </form>
          </div>
        </div>
      </main>
      <LandingPageFooter />
    </div>
  );
}
